import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { ServicingBaseComponent } from '@common/components';
import { MY_BOOKING_TAB_IDENTIFIER, PREVIOUS_PAGE_IDENTIFIER } from '@common/interfaces/servicing-common';
import { ServicingCommonStoreService } from '@common/services/servicing-common-store/servicing-common-store.service';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { AswContextType } from '@lib/interfaces';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-my-car-valet-request-sub-header',
  templateUrl: './my-car-valet-request-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyCarValetRequestSubHeaderComponent extends ServicingBaseComponent {
  // 戻るボタン遷移先：予約詳細画面(S01-P030)
  backUrl: string = SERVICING_ROUTES.myBooking;

  constructor(
    private _commonLibService: CommonLibService,
    private _router: Router,
    private _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    super(_commonLibService);
  }

  override init(): void {}
  override reload(): void {}
  override destroy(): void {}

  back(): void {
    // 言語設定(前画面にて保持されたバックアップ用言語設定)
    this._commonLibService.aswContextStoreService.updateAswContextByKey(
      AswContextType.LANG,
      this._servicingCommonStoreService.servicingCommon.backupLanguage
    );

    // 予約詳細表示タブ=”service”(予約詳細(サービス))を保持
    this._servicingCommonStoreService.updateServicingCommon({
      tabShow: MY_BOOKING_TAB_IDENTIFIER.SERVICE,
      previousPageIdentifier: PREVIOUS_PAGE_IDENTIFIER.MY_CAR_VALET_REQUEST,
    });
  }
}
